import React from 'react';

interface DateDisplayProps {
    children: string | Date | number;
    format?: string;
}

/**
 * A modern date formatting component using native JavaScript Date and Intl.DateTimeFormat
 * Replaces react-moment with better performance and smaller bundle size
 */
const DateDisplay: React.FC<DateDisplayProps> = ({ children, format = 'YYYY/MM/DD' }) => {
    if (!children) {
        return null;
    }

    try {
        const date = new Date(children);

        if (isNaN(date.getTime())) {
            console.warn('DateDisplay: Invalid date provided', children);
            return <span>{String(children)}</span>;
        }

        // Handle different format patterns
        let formattedDate: string;

        if (format === 'YYYY/MM/DD') {
            // Use Intl.DateTimeFormat for consistent formatting
            formattedDate = new Intl.DateTimeFormat('en-CA').format(date); // en-CA gives YYYY-MM-DD
            formattedDate = formattedDate.replace(/-/g, '/'); // Convert to YYYY/MM/DD
        } else {
            // For other formats, we can extend this as needed
            // For now, default to a readable format
            formattedDate = new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(date);
        }

        return <span>{formattedDate}</span>;
    } catch (error) {
        console.warn('DateDisplay: Error formatting date', children, error);
        return <span>{String(children)}</span>;
    }
};

export default DateDisplay;
